var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 21,
    viewBox: "0 0 14 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 0C5.1441 0.00202131 3.3648 0.740168 2.05248 2.05248C0.740168 3.3648 0.00202131 5.1441 0 7C0 12.5656 6.25291 19.8367 6.51891 20.1447L7 20.6984L7.48109 20.1435C7.74709 19.8367 14 12.5656 14 7C14 3.13982 10.8589 0 7 0ZM7 18.7282C5.54145 16.9158 1.27273 11.2458 1.27273 7C1.27273 3.84236 3.84236 1.27273 7 1.27273C10.1576 1.27273 12.7273 3.84236 12.7273 7C12.7273 11.242 8.45855 16.9158 7 18.7282ZM7 3.35873C4.89491 3.35873 3.18182 5.07182 3.18182 7.17691C3.18182 9.282 4.89491 10.9951 7 10.9951C9.10509 10.9951 10.8182 9.282 10.8182 7.17691C10.8182 5.07182 9.10509 3.35873 7 3.35873ZM7 9.72236C5.59618 9.72236 4.45455 8.58073 4.45455 7.17691C4.45455 5.77309 5.59618 4.63145 7 4.63145C8.40382 4.63145 9.54545 5.77309 9.54545 7.17691C9.54545 8.58073 8.40382 9.72236 7 9.72236Z",
    fill: "#FF9F24"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapOrange);
export default __webpack_public_path__ + "static/media/map-orange.9391598304e0a2db7768a141aae21a1d.svg";
export { ForwardRef as ReactComponent };